"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CertificateVerificationRecord = void 0;
var certificate_verification_record_1 = require("./certificate-verification-record");
Object.defineProperty(exports, "CertificateVerificationRecord", { enumerable: true, get: function () { return certificate_verification_record_1.CertificateVerificationRecord; } });
